import { render, staticRenderFns } from "./GPClickEvent.vue?vue&type=template&id=7a76d319&"
import script from "./GPClickEvent.vue?vue&type=script&lang=js&"
export * from "./GPClickEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports